import React, { useState, useEffect } from "react";

const JSONUpdater = () => {
    const [data, setData] = useState(null);
    const API_URL = "https://api.jsonbin.io/v3/b/67d709c78960c979a572c6ff";
    const API_KEY = "$2a$10$AQ3dSRuvXpwDHFP7DEHZQeMuSzzOCiZd5henx5hrSX1cA/GTC57G2";

    useEffect(() => {
        fetch(API_URL, {
            headers: {
                "X-Master-Key": API_KEY
            }
        })
            .then(response => response.json())
            .then(data => setData(data.record))
            .catch(error => console.error("Erreur lors du chargement :", error));
    }, []);

    const handleChange = (section, index, field, value) => {
        const updatedData = { ...data };
        updatedData[section][index][field] = value;
        setData(updatedData);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            await fetch(API_URL, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "X-Master-Key": API_KEY
                },
                body: JSON.stringify(data)
            });
            alert("Données mises à jour avec succès !");
        } catch (error) {
            console.error("Erreur lors de la mise à jour :", error);
        }
    };

    if (!data) {
        return <div className="loading">Chargement des données...</div>;
    }

    return (
        <div className="json-updater-container">
            <h1 className="main-title">Mettre à jour les dates</h1>
            <p><span style={{ fontSize: "40px"}}>&#9888;</span> Format requis : jour/mois/année</p>

            <form onSubmit={handleSubmit} className="date-form">
                {/* Vacances Scolaires */}
                <section className="date-section">
                    <h2 className="section-title">Vacances Scolaires</h2>
                    <div className="date-grid">
                        {data.vacanceScolaire.map((vacance, index) => (
                            <div key={index} className="date-card">
                                <h3 className="card-title">Vacance {index + 1}</h3>
                                <div className="input-group">
                                    <label>
                                        Date de début:
                                        <input
                                            type="text"
                                            value={vacance.start}
                                            placeholder={'ex : 24/12/2025'}
                                            onChange={(e) =>
                                                handleChange("vacanceScolaire", index, "start", e.target.value)
                                            }
                                            className="date-input"
                                        />
                                    </label>
                                </div>
                                <div className="input-group">
                                    <label>
                                        Date de fin:
                                        <input
                                            type="text"
                                            value={vacance.end}
                                            onChange={(e) =>
                                                handleChange("vacanceScolaire", index, "end", e.target.value)
                                            }
                                            className="date-input"
                                        />
                                    </label>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                {/* Foire de Bourail */}
                <section className="date-section">
                    <h2 className="section-title">Foire de Bourail</h2>
                    <div className="date-grid">
                        {data.foireDeBourail.map((foire, index) => (
                            <div key={index} className="date-card">
                                <h3 className="card-title">Foire {index + 1}</h3>
                                <div className="input-group">
                                    <label>
                                        Date de début:
                                        <input
                                            type="text"
                                            value={foire.start}
                                            onChange={(e) =>
                                                handleChange("foireDeBourail", index, "start", e.target.value)
                                            }
                                            className="date-input"
                                        />
                                    </label>
                                </div>
                                <div className="input-group">
                                    <label>
                                        Date de fin:
                                        <input
                                            type="text"
                                            value={foire.end}
                                            onChange={(e) =>
                                                handleChange("foireDeBourail", index, "end", e.target.value)
                                            }
                                            className="date-input"
                                        />
                                    </label>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                {/* Saisons Basse */}
                <section className="date-section">
                    <h2 className="section-title">Saisons Basse</h2>
                    <div className="date-grid">
                        {data.saisonsBasse.map((saison, index) => (
                            <div key={index} className="date-card">
                                <h3 className="card-title">Saison Basse {index + 1}</h3>
                                <div className="input-group">
                                    <label>
                                        Date de début:
                                        <input
                                            type="text"
                                            value={saison.start}
                                            onChange={(e) =>
                                                handleChange("saisonsBasse", index, "start", e.target.value)
                                            }
                                            className="date-input"
                                        />
                                    </label>
                                </div>
                                <div className="input-group">
                                    <label>
                                        Date de fin:
                                        <input
                                            type="text"
                                            value={saison.end}
                                            onChange={(e) =>
                                                handleChange("saisonsBasse", index, "end", e.target.value)
                                            }
                                            className="date-input"
                                        />
                                    </label>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                <button type="submit" className="submit-btn">Mettre à jour</button>
            </form>

            <style jsx>{`
                .json-updater-container {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 2rem;
                    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                }

                .main-title {
                    text-align: center;
                    color: #2c3e50;
                    margin-bottom: 2rem;
                }

                .date-form {
                    background-color: #f9f9f9;
                    padding: 2rem;
                    border-radius: 8px;
                    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
                }

                .date-section {
                    margin-bottom: 2.5rem;
                }

                .section-title {
                    color: #3498db;
                    border-bottom: 2px solid #3498db;
                    padding-bottom: 0.5rem;
                    margin-bottom: 1.5rem;
                }

                .date-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
                    gap: 1.5rem;
                }

                .date-card {
                    background: white;
                    padding: 1.5rem;
                    border-radius: 6px;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                }

                .card-title {
                    color: #2c3e50;
                    margin-top: 0;
                    margin-bottom: 1rem;
                    font-size: 1.1rem;
                }

                .input-group {
                    margin-bottom: 1rem;
                }

                .input-group label {
                    display: block;
                    margin-bottom: 0.5rem;
                    color: #7f8c8d;
                    font-weight: 500;
                }

                .date-input {
                    width: 100%;
                    padding: 0.75rem;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                    font-size: 1rem;
                    transition: border-color 0.3s;
                }

                .date-input:focus {
                    outline: none;
                    border-color: #3498db;
                }

                .submit-btn {
                    display: block;
                    width: 100%;
                    max-width: 200px;
                    margin: 2rem auto 0;
                    padding: 0.75rem;
                    background-color: #3498db;
                    color: white;
                    border: none;
                    border-radius: 4px;
                    font-size: 1rem;
                    cursor: pointer;
                    transition: background-color 0.3s;
                }

                .submit-btn:hover {
                    background-color: #2980b9;
                }

                .loading {
                    text-align: center;
                    padding: 2rem;
                    color: #7f8c8d;
                }
            `}</style>
        </div>
    );
};

export default JSONUpdater;